import moment from 'moment'
import { flatten, orderBy, values, last } from 'lodash'

import { round } from '../../lib/Tools.js'
import { getStatusLabel } from '../trips/TripStatus.js'
import { getBI } from '../reservations/ReservationTools'

import { 
  calculateTripPrice, getPaidTotals, getTotalCommissions, 
  getTripCode, countAdults, countKids 
} from '../../lib/TripTools.js'

/**
 * 
 */
function sum(a = 0, b = 0) { return (a || 0) + (b || 0) }

export default function getSellsReportData(
  trips: Object[], 
  routes: Object, 
  activities: {[string]: Object}, 
  cities: {[string]: Object}, 
  reservations: {[string]: Object},
  isProduction: boolean,
  progressCallback: ?((number, number) => void)
): Promise<any[][]>
{
  const reportsTop = trips.length - 1

  // quiero mínimo 4 steps
  const step = Math.min(200, Math.floor(reportsTop / 4))

  const stepResults = []

  function doTrip(t, i) {
    if (progressCallback && (i % step == 0 || i == reportsTop)) {
      progressCallback(i, reportsTop)
    } 

    //const factorGestion = (100 + t.pGestion) / 100
    const costesIVA = values(reservations).filter(r => r.tripId == t._id).map(r => r.finalPrice)
    const costesSinIVA = values(reservations).filter(r => r.tripId == t._id).map(r => getBI(r))
    const costeTotalSinIVA = costesSinIVA.length > 0 ? costesSinIVA.reduce(sum) : 0
    const costeTotalIVA = costesIVA.length > 0 ? costesIVA.reduce(sum) : 0
    const cobros = t.payments.filter(x => x.isReceived).map(x => x.receivedEur || 0)
    const totalCobrado = cobros.length > 0 ? cobros.reduce(sum) : 0
    const exempt = t.exemptMoney + t.otherExempt
    const margen = exempt + ((totalCobrado - exempt) / 1.21) - costeTotalSinIVA 
    const totalCommission = getTotalCommissions(t)
    const margenTotal = margen + totalCommission
    const porcentaje = margenTotal  / (((totalCobrado - exempt) / 1.21) + exempt)

    const totals = getPaidTotals(t)
    const r = routes[t.mainRoute]
    const finalPrice = (t.mainRoute && r.agenda) ? calculateTripPrice(t, r, activities, cities).finalE : 0
    const name = (t.name && t.realName) ? `${t.realName} (${t.name})` : t.name || t.realName

    const adults = countAdults(t)
    const kids = countKids(t)
    
    // console.log(` -- Reporte, viaje ${i}, id ${t._id}, con mainRoute ${t.mainRoute}`)
    // console.log({ t, r: routes[t.mainRoute] })

    return [
      t.tags.SPOT ? "spot" : "", 
      getStatusLabel(t.status),
      t._id,
      name,
      t.receiptNumber ? `${t.receiptNumber}/${t.receiptYear}` : "Sin numero factura",
      t.receiptDate ? t.receiptDate : "Sin fecha factura",
      t.receiptValue ? parseFloat(t.receiptValue).toFixed(2) : (0).toFixed(2),
      (
        t.payments.length > 0 
          ? (
            t.payments[0].sentDate 
              ? moment(t.payments[0].sentDate).format("YYYY/MM/DD") 
              : "Pago sin fecha"
          )
          : "Sin pagos"
      ),
      adults || 0,
      kids || 0,
      t.encargado,
      moment(t.creation).format("YYYY/MM/DD"),
      moment(t.startDate).format("YYYY/MM/DD"),
      moment(t.endDate).format("YYYY/MM/DD"),
      (finalPrice || 0).toFixed(2),
      (totals.eur || 0).toFixed(2),
      (totals.receivedEur || 0).toFixed(2),
      ((finalPrice - totals.eur) || 0).toFixed(2),

      // #TODO Usar url tripmaker.es en produccion
      (costeTotalSinIVA || 0).toFixed(2),
      (costeTotalIVA || 0).toFixed(2),
      (totalCommission || 0).toFixed(2),
      (margenTotal || 0).toFixed(2),
      `${round(porcentaje * 100, 0.01)} %`,
      getTripCode(t), 
      t.notes.length ? last(t.notes).text : "",
      `[Ver ${name} en Tripmaker](http://${isProduction ? "tripmaker.es" : "localhost:3003"}/private/trip/${t._id})`,
      t.clientChannel || "unknown", 
      t.channelComment 
    ]

  }

  // #TODO why isn't this a promise?
  function doStep(from, endCallback) {
    console.log(`STEP: About to undertake step from ${from}`)

    const myData = trips.slice(from, from + step).map(doTrip)
    stepResults.push(myData)

    progressCallback(Math.min(from + step, reportsTop), reportsTop)

    // #TODO validate this is not an error-by-one. with several lengths!
    if ((from + step) <= reportsTop) {
      console.log(`STEP: Let's go for the next, from ${from + step}`)
      setTimeout(() => doStep(from + step, endCallback), 100)
    }
    else {
      console.log(`STEP: It seems I was the last step...`)
      setTimeout(() => endCallback(), 100)
    }
  }

  return new Promise(yea => {
    function doEnd() {
      const results = flatten(stepResults)

      const final = [
        [
          "Clase", 
          "Estado", 
          "Id",
          "Cliente",
          "Nº Factura",
          "Fecha factura",
          "Facturación",
          "Fecha 1er Pago",
          "Adultos",
          "Niños", 
          "Encargado", 
          "Creación",
          "Llegada", 
          "Retorno", 
          "Precio",
          "Pagado",
          "Recibido",
          "Deuda",
          "Coste-BI",
          "Coste-Total",
          "Comisión Booking",
          "Margen Total",
          "% Margen",
          "Código", 
          "Último mensaje",
          "Enlace",
          "Canal", 
          "Canal comentario"
        ], 
        ...results
      ]

      yea(final)
    }

    doStep(0, doEnd)
  })
}
